import { useEffect, useState } from "react";
import { Card, Button, Select, Pagination, Spin } from "antd";
import { StarFilled, InfoCircleOutlined } from "@ant-design/icons";
import Avvvatars from "avvvatars-react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import ModalPromotion from "./modal_promotion";
import { getAverageByPromotion } from "../../api/classement";
import { toast } from "sonner";
import { getAllLevel } from "../../api/pedagogicElement";
import {
  Action,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import { Link } from "react-router";
import { my_routes } from "../router/all_routes";
import { getAllCycle } from "../../api/settings";

const { Option } = Select;

const ClassementByPromotion = () => {
  const routes = my_routes;

  const [showModal, setShowModal] = useState(false);
  const [cycle, setCycle] = useState<any>();
  const [selectedYears, setSelectedYears] = useState<string[]>([]);
  const [promotionYears, setPromotionYears] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [students, setStudents] = useState<any[]>([]);
  const [paginatedStudents, setPaginatedStudents] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState<number>(5);

  const [allCycle, setAllCycle] = useState<any[]>([]);

  //   récupérer les moyennes de la promotion sélectionnée
  const fetchAveragePromotion = async () => {
    setIsLoading(true);
    if (!cycle || promotionYears.length === 0) {
      toast.error("Veuillez sélectionner un cycle et des années.");
      return;
    }
    try {
      // console.log("promotionYears: ", promotionYears);
      const response = await getAverageByPromotion({
        id_cycle: cycle?.id,
        id_academicYear: promotionYears[0].id,
      });
      // console.log("Response: ", response);

      setStudents(response.data.sort((a: any, b: any) => a.rank - b.rank));
      setIsLoading(false);
    } catch (error: any) {
      // console.log("erreur récupération des moyennes de la promotion: ", error);
      setIsLoading(false);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // recuperer tous les parcours
  const fetchAllCycle = async () => {
    try {
      const response = await getAllCycle();

      // console.log('tous les cycles: ', response.data)
      setAllCycle(response.data);
    } catch (error: any) {
      // console.log("Erreur lors de la recuperation des parcours: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  useEffect(() => {
    fetchAllCycle();
  }, []);
  useEffect(() => {
    if (promotionYears.length === 0) return;
    fetchAveragePromotion();
  }, [promotionYears]);

  useEffect(() => {
    if (students.length === 0) return;
    const sorted = [...students].sort((a: any, b: any) => a.rank - b.rank);
    const startIndex = (page - 1) * pageSize;
    const endIndex = page * pageSize;
    setPaginatedStudents(sorted.slice(startIndex, endIndex));
  }, [students, page, pageSize]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
          {/* 🧭 En-tête */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">
                Classement des étudiants (Promotion)
              </h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.allNotes}>Notes</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Classement par promotion
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <Button
            type="primary"
            onClick={() => {
              setShowModal(true);
            }}
          >
            Sélectionner une promotion
          </Button>
        </div>

        {/* Layout responsive : infos à gauche, classement à droite */}
        <div className="d-flex flex-column flex-lg-row gap-4">
          {cycle && promotionYears.length > 0 && (
            <Card
              className="flex-shrink-0 shadow-sm"
              style={{
                background: "linear-gradient(135deg, #f7faff 0%, #ffffff 100%)",
                borderRadius: 12,
                flex: "0 0 300px",
              }}
            >
              <div className="d-flex align-items-center mb-3">
                <InfoCircleOutlined
                  style={{ fontSize: 20, color: "#1890ff" }}
                />
                <h5 className="ms-2 mb-0 fw-semibold">
                  Détails de la promotion
                </h5>
              </div>
              <div className="ms-2">
                <p>
                  <strong>Cycle choisi :</strong>{" "}
                  <span className="text-primary text-capitalize">
                    {cycle?.label}
                  </span>
                </p>

                <p>
                  <strong>Nombre d’étudiants :</strong> {students.length}
                </p>
                <div className="mt-2">
                  <strong>Années du cycle :</strong>
                  <ul className="mt-2">
                    {promotionYears.map((year, i) => (
                      <li key={year.id}>
                        {year.label} : {cycle?.label}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Card>
          )}

          {/* 🏆 Classement */}
          {isLoading ? (
            <Card className="flex-grow-1 p-3 d-flex justify-content-center align-items-center">
              <Spin size="large" />
            </Card>
          ) : (
            <Card className="flex-grow-1 ">
              {paginatedStudents.length > 0 ? (
                <div className="d-flex flex-column">
                  <div
                    className=" d-flex flex-column gap-3 overflow-auto w-100"
                    style={{ maxHeight: "calc(100vh - 220px)" }}
                  >
                    {paginatedStudents.map((student, index) => {
                      const isTop3 =
                        students.findIndex(
                          (item) => item.studentId === student.studentId,
                        ) +
                          1 <=
                        3;
                      return (
                        <div
                          key={student?.studentId}
                          className="d-flex align-items-center p-3 mb-2 shadow-sm"
                          style={{
                            background: isTop3
                              ? "rgba(0, 123, 255, 0.08)"
                              : "#fff",
                            borderRadius: 10,
                            border: isTop3
                              ? "2px solid #1890ff"
                              : "1px solid #eee",
                            gap: "1rem",
                          }}
                        >
                          {/* Rang + médaille */}
                          <div
                            style={{ flex: "0 0 80px", textAlign: "center" }}
                          >
                            {isTop3 ? (
                              <ImageWithBasePath
                                src={`assets/img/top_of_class_${index + 1}.png`}
                                alt="Médaille"
                                width={50}
                                height={50}
                              />
                            ) : (
                              <span
                                className="text-primary fw-bold"
                                style={{
                                  display: "inline-block",
                                  width: 50,
                                  height: 50,
                                  lineHeight: "50px",
                                  borderRadius: "50%",
                                  background: "#f0f0f0",
                                }}
                              >
                                {students.findIndex(
                                  (item) =>
                                    item.studentId === student.studentId,
                                ) + 1}
                              </span>
                            )}
                          </div>

                          {/* Avatar + Infos */}
                          <div
                            style={{
                              flex: "1 1 250px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Avvvatars
                              value={`${student?.name?.charAt(0) || ""}${
                                student?.name?.charAt(1) || ""
                              }`}
                              style="character"
                            />
                            <div className="ms-2 overflow-hidden">
                              <p
                                className="text-dark mb-0 text-truncate"
                                style={{ maxWidth: 180 }}
                              >
                                <Link
                                  to={`/student-detail/${student?.studentId}`}
                                >
                                  {student?.fullname}
                                </Link>
                              </p>
                              <span className="fs-12 text-muted">
                                {student?.matricule}
                              </span>
                            </div>
                          </div>

                          {/* Dernière classe */}
                          <div style={{ flex: "1 1 250px" }}>
                            <p className="text-dark mb-0">Dernière classe</p>
                            <span
                              className="fs-12 text-muted text-truncate d-block"
                              style={{ maxWidth: 220 }}
                            >
                              {student?.lastClassLabel}
                            </span>
                          </div>
                          {student?.moyenneYears.length > 0 && (
                            <>
                              {student?.moyenneYears
                                .sort((a: any, b: any) =>
                                  a.label_annee.localeCompare(b.label_annee),
                                )
                                .map((avg: any) => (
                                  <div style={{ flex: "1 1 250px" }}>
                                    <p className="text-dark mb-0">
                                      {avg?.label_annee}
                                    </p>
                                    <span
                                      className="fs-12 text-muted text-truncate d-block"
                                      style={{ maxWidth: 220 }}
                                    >
                                      {avg?.moyenne.toFixed(2) || "_ _"}
                                    </span>
                                  </div>
                                ))}
                            </>
                          )}

                          {/* Moyenne */}
                          <div>
                            <div
                              style={{ flex: "0 0 100px", textAlign: "right" }}
                            >
                              <StarFilled style={{ color: "#faad14" }} />{" "}
                              <span className="fw-bold">
                                {student?.cycleAverage?.toFixed(2) || "_ _"}
                              </span>{" "}
                              / 20
                            </div>
                            <span className="fs-12 text-muted">
                              {student?.mention}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <span>Afficher :</span>
                      <Select
                        value={pageSize}
                        style={{ width: 80 }}
                        onChange={(value) => {
                          setPageSize(value);
                          setPage(1);
                        }}
                        options={[
                          { value: 5, label: "5" },
                          { value: 10, label: "10" },
                          { value: 20, label: "20" },
                          { value: 50, label: "50" },
                        ]}
                      />
                      <span>par page</span>
                    </div>
                    <Pagination
                      current={page}
                      total={students.length}
                      pageSize={pageSize}
                      // showSizeChanger
                      pageSizeOptions={["5", "10", "20", "50"]}
                      onChange={(p, size) => {
                        setPage(p);
                        setPageSize(size);
                      }}
                      showTotal={(total, range) => (
                        <span>
                          {range[0]}–{range[1]} sur {total} étudiants
                        </span>
                      )}
                    />
                  </div>
                </div>
              ) : (
                <div className="text-center text-muted py-5">
                  Aucun classement disponible
                </div>
              )}
            </Card>
          )}
        </div>

        {/* 🎓 Modal de sélection */}
        <ModalPromotion
          showModal={showModal}
          setShowModal={setShowModal}
          error={error}
          setError={setError}
          cycles={allCycle}
          cycle={cycle || ""}
          setCycle={setCycle}
          selectedYears={selectedYears}
          setSelectedYears={setSelectedYears}
          setPromotionYears={setPromotionYears}
        />
      </div>
    </div>
  );
};

export default ClassementByPromotion;
